import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_3Xs9A",
  "use": "dashboard_3Xs9A-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dashboard_3Xs9A\">\n    <polyline points=\"4,20 8,12 13,15 19,6\" stroke=\"currentColor\" fill=\"none\" strokeWidth=\"2\" />\n    <circle cx=\"4\" cy=\"20\" r=\"1.5\" fill=\"currentColor\" />\n    <circle cx=\"8\" cy=\"12\" r=\"1.5\" fill=\"currentColor\" />\n    <circle cx=\"13\" cy=\"15\" r=\"1.5\" fill=\"currentColor\" />\n    <circle cx=\"19\" cy=\"6\" r=\"1.5\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol